// extracted by mini-css-extract-plugin
export var list = "toc-module--list--X+4Fp";
export var sbShowMain = "toc-module--sb-show-main--eHEtr";
export var title = "toc-module--title--+kSTG";
export var toc = "toc-module--toc--UabTq";